import { render, staticRenderFns } from "./CoTwoEnergyForm.vue?vue&type=template&id=3865e19d&scoped=true&"
import script from "./CoTwoEnergyForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoEnergyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3865e19d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3865e19d')) {
      api.createRecord('3865e19d', component.options)
    } else {
      api.reload('3865e19d', component.options)
    }
    module.hot.accept("./CoTwoEnergyForm.vue?vue&type=template&id=3865e19d&scoped=true&", function () {
      api.rerender('3865e19d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoEnergyForm.vue"
export default component.exports